<template>
  <div class="index">
    <!-- <div v-show="showbtn" style=" position: fixed;width:100%;height:100%;z-index: 999; color: #222;opacity: 0.5;">
          
    </div> -->
    <div class="news">
      <img src="../../../static/image/list.png" alt="" />
      <el-carousel class="carousel" height="60px" direction="vertical">
        <el-carousel-item v-for="item in newsList" :key="item.ID">
          <span style="color: #999999"
            >[{{ item.publishtime }}] &nbsp;&nbsp;</span
          >
          <span>{{ item.title }}</span>
        </el-carousel-item>
      </el-carousel>
      <div class="more" @click="toMoreNews">
        <span>更多新闻 ></span>
      </div>
    </div>
    <div class="showFeatures">
      <el-row type="flex" justify="space-around" class="new-item">
        <el-col
          :span="6"
          class="enterBox"
          v-on:mouseenter.native="onmouseenter7"
          v-on:mouseleave.native="onmouseleave7"
        >
          <a href="#" @click="linkTo(14)">
            <div class="imgBox">
              <img
                src="../../assets/w7.png"
                alt=""
                v-show="isImage7 === true"
              />
              <img
                src="../../assets/b7.png"
                alt=""
                v-show="isImage7 === false"
              />
            </div>
            <p class="title">医晟宝核收端</p>
            <p>仅华晟销售及物流人员登录</p>
          </a>
        </el-col>
        <el-col
          :span="6"
          class="enterBox"
          v-on:mouseenter.native="onmouseenter5"
          v-on:mouseleave.native="onmouseleave5"
        >
          <a href="#" @click="linkTo(12)">
            <div class="imgBox">
              <img
                src="../../assets/w5.png"
                alt=""
                v-show="isImage5 === true"
              />
              <img
                src="../../assets/b5.png"
                alt=""
                v-show="isImage5 === false"
              />
            </div>
            <p class="title">医晟宝PC端</p>
            <p>仅限诊所医护人员登录</p>
          </a>
        </el-col>
        <el-col
          :span="6"
          class="enterBox"
          v-on:mouseenter.native="onmouseenter8"
          v-on:mouseleave.native="onmouseleave8"
        >
          <div @click="linkTo(15)">
            <div class="imgBox">
              <img
                src="../../assets/w8.png"
                alt=""
                v-show="isImage8 === true"
              />
              <img
                src="../../assets/b8.png"
                alt=""
                v-show="isImage8 === false"
              />
            </div>
            <p class="title">医晟宝小程序</p>
            <p>仅限诊所医护人员登录</p>
          </div>
        </el-col>
        <el-col
          :span="6"
          class="enterBox"
          v-on:mouseenter.native="onmouseenter6"
          v-on:mouseleave.native="onmouseleave6"
        >
          <a href="#" @click="linkTo(13)">
            <div class="imgBox">
              <img
                src="../../assets/w6.png"
                alt=""
                v-show="isImage6 === true"
              />
              <img
                src="../../assets/b6.png"
                alt=""
                v-show="isImage6 === false"
              />
            </div>
            <p class="title">华晟医学后台</p>
            <p>仅本公司内部人员登录</p>
          </a>
        </el-col>
      </el-row>
      <el-row type="flex" justify="space-around">
        <el-col
          :span="6"
          class="enterBox"
          style="text-align: center; cursor: pointer"
        >
          <div
            @click="showButton"
            href="#"
            v-on:mouseenter="onmouseenter4"
            v-on:mouseleave="onmouseleave4"
          >
            <!-- @click="linkTo(6)" -->
            <div class="imgBox">
              <img
                src="../../assets/w4.png"
                alt=""
                v-show="isImage4 === true"
              />
              <img
                src="../../assets/b4.png"
                alt=""
                v-show="isImage4 === false"
              />
            </div>
            <p class="title" v-show="isImage4 === true">报告单查询系统</p>
            <p class="title" style="color: #0068b7" v-show="isImage4 === false">
              报告单查询系统
            </p>
            <p class="tip" v-show="isImage4 === true">更多查询系统</p>
            <p class="tip" v-show="isImage4 === false" style="color: #0068b7">
              更多查询系统
            </p>
          </div>
        </el-col>
        <!-- <el-col
          :span="6"
          class="enterBox"
          v-on:mouseenter.native="onmouseenter0"
          v-on:mouseleave.native="onmouseleave0"
        >
          <a href="#" @click="linkTo(0)">
            <div class="imgBox">
              <img
                src="../../assets/w0.png"
                alt=""
                v-show="isImage0 === true"
              />
              <img
                src="../../assets/b0.png"
                alt=""
                v-show="isImage0 === false"
              />
            </div>
            <p class="title">赴日新冠预约</p>
            <p class="tip">预约说明及操作指导</p>
          </a>
        </el-col> -->
        <el-col
          :span="6"
          class="enterBox"
          v-on:mouseenter.native="onmouseenter"
          v-on:mouseleave.native="onmouseleave"
        >
          <a href="#" @click="linkTo(1)">
            <div class="imgBox">
              <img src="../../assets/w1.png" alt="" v-show="isImage === true" />
              <img
                src="../../assets/b1.png"
                alt=""
                v-show="isImage === false"
              />
            </div>
            <p class="title">江河云诊所</p>
            <p class="tip">诊所医疗信息化SaaS服务平台</p>
          </a>
        </el-col>
        <el-col
          :span="6"
          class="enterBox"
          v-on:mouseenter.native="onmouseenter2"
          v-on:mouseleave.native="onmouseleave2"
        >
          <a href="#" @click="linkTo(2)">
            <div class="imgBox">
              <img
                src="../../assets/w2.png"
                alt=""
                v-show="isImage2 === true"
              />
              <img
                src="../../assets/b2.png"
                alt=""
                v-show="isImage2 === false"
              />
            </div>
            <p class="title">微E检</p>
            <p class="tip">基层医疗检验互联网平台</p>
          </a>
        </el-col>
        <el-col
          :span="6"
          class="enterBox"
          v-on:mouseenter.native="onmouseenter3"
          v-on:mouseleave.native="onmouseleave3"
        >
          <a href="#" @click="linkTo(3)">
            <div class="imgBox">
              <img
                src="../../assets/w3.png"
                alt=""
                v-show="isImage3 === true"
              />
              <img
                src="../../assets/b3.png"
                alt=""
                v-show="isImage3 === false"
              />
            </div>
            <p class="title">E晟宝</p>
            <p class="tip">全民健康管理运营平台</p>
          </a>
        </el-col>
      </el-row>
    </div>
    <el-dialog title="华晟医学" :visible.sync="showbtn" class="homeSend">
      <el-button
        @click="linkTo(7)"
        style="
          width: 350px;
          margin: auto;
          height: 40px;
          font-size: 16px;
          margin-bottom: 10px;
          border: 1px solid #ccc;
          background-color: #f4f4f4;
        "
        >江河华晟医学检验实验室（江苏）- 电信</el-button
      >
      <el-button
        @click="linkTo(6)"
        style="
          width: 350px;
          margin: auto;
          height: 40px;
          font-size: 16px;
          margin-bottom: 10px;
          border: 1px solid #ccc;
          background-color: #f4f4f4;
        "
        >江河华晟医学检验实验室（江苏）- 联通</el-button
      >
      <el-button
        @click="linkTo(8)"
        style="
          width: 350px;
          margin: auto;
          height: 40px;
          font-size: 16px;
          margin-bottom: 10px;
          border: 1px solid #ccc;
          background-color: #f4f4f4;
        "
        >江河华晟医学检验实验室（湖南）- 电信</el-button
      >
      <!-- <el-button
        @click="linkTo(9)"
        style="
          width: 350px;
          margin: auto;
          height: 40px;
          font-size: 16px;
          margin-bottom: 10px;
          border: 1px solid #ccc;
          background-color: #f4f4f4;
        "
        >江河华晟医学检验实验室（湖南）- 联通</el-button
      > -->
      <el-button
        @click="linkTo(10)"
        style="
          width: 350px;
          margin: auto;
          height: 40px;
          font-size: 16px;
          margin-bottom: 10px;
          border: 1px solid #ccc;
          background-color: #f4f4f4;
        "
        >江河华晟医学检验实验室（河南）- 电信</el-button
      >
      <!-- <el-button
        @click="linkTo(11)"
        style="
          width: 350px;
          margin: auto;
          height: 40px;
          font-size: 16px;
          margin-bottom: 10px;
          border: 1px solid #ccc;
          background-color: #f4f4f4;
        "
        >江河华晟医学检验实验室（河南）- 联通</el-button
      > -->
      <div style="margin-top: 20px">
        查询往年历史报告，请拨打服务热线： 400-894-5099
      </div>
    </el-dialog>
    <el-dialog
      title="医晟宝小程序"
      :visible.sync="showCode"
      top="0vh"
      class="homeSend"
    >
      <img
        src="../../assets/wcode.jpg"
        alt="医晟宝小程序"
        style="width: 300px; height: 300px"
      />
      <div style="font-size: 16px; margin-top: 15px">
        手机微信扫码打开(医晟宝)小程序
      </div>
      <!-- <el-image src="../../assets/wcode.jpg" style="width:400px;height:400px"></el-image> -->
    </el-dialog>
    <div class="introduce">
      <div class="description">
        <p class="top">江河华晟医学，中国领先的“互联网+基层医疗”产业平台</p>
        <p style="line-height: 25px; color: #333">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;南京江河华晟医学科技有限公司(以下简称“江河华晟医学”)总部位于南京市江北新区生物医药谷中丹生态生命科学产业园，是一家以第三方医学检验实验室投资、运营、服务为核心业务的创新型医疗服务机构，先后获评"南京市培育独角兽企业"、"科技型中小企业"，旗下子公司南京江河华晟获评 "高新技术企业"。
          <br /><br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;江河华晟医学致力于为基层医疗机构提供诊断解决方案，围绕感染性疾病、代谢性疾病、遗传性疾病三大检测平台，聚焦在妇儿健康、病原体检测、慢病（三高）并发症、肿瘤早筛、公卫项目（老年人体检、两癌筛查、疫情防控）等疾病的预防和治疗领域，为广大客户提供诊断、鉴别诊断、伴随诊断的专业服务。
          <br /><br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;江河华晟医学在江苏南京、湖南长沙、河南郑州先后投资建设了三所现代化全科医学检验实验室，总建筑面积逾1.3万平方米。均开设有临检、生化、免疫、微生物、分子诊断、病理（细胞病理、组织病理）等专业科室。江河华晟医学旗下实验室均参加了所在省市和国家临检中心室间质评，且历年来各项质评成绩均为优秀。其中，南京总部实验室于2023年6月4日顺利通过ISO15189现场评审。
          <br /><br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;公司现有全职员工400余人，其中数智研发部IT工程师近40人，经过长达三年的持续研发，公司基于医学检验全场景、全过程的数字化解决方案的数字化产品体系已开发完成，可以为医生、基层医院、卫健委以及常态化疫情防控提供基于云存储、云计算、云智能等Saas服务及数字化解决方案。
          <br /><br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 未来三年，公司计划在武汉、成都、济南、上海等城市投资建设连锁实验室，进一步扩大业务规模。同时，加强学科建设，提升核心能力，引进分子诊断领域的学科带头人，进一步拓展市场，为客户提供更加满意的产品和服务。
          <br /><br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 面向未来，江河华晟医学将以第三方医学检验为基础和纽带，聚焦在医疗大健康领域，为患者和健康人群提供疾病诊断和疾病预防服务，通过线上产品、线下业务的协同发展，赋能基层医疗机构，护卫百姓健康，矢志成为中国领先的“检验服务＋产品＋数字化”创新型医疗服务机构，与健康中国一路同行。
        </p>
      </div>
      <el-row style="padding-top: 40px" type="flex" justify="space-around">
        <el-col :span="24">
          <div class="imgBox">
            <img src="../../assets/rddt3.png" alt="" />
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="show clearfix">
      <el-row type="flex" justify="space-between">
        <el-col :span="7" class="item">
          <a href="javascript:volid(0)">
            <img src="../../../static/image/zhixun.png" alt="" />
            <div class="item_content">
              <p>检验咨询</p>
              <p class="inner animated bounce">
                科学的建议与方法，解决您的烦恼，为您的健康把关。
              </p>
            </div>
          </a>
        </el-col>
        <el-col :span="7" class="item">
          <a href="javascript:volid(0)">
            <img src="../../../static/image/shebei.png" alt="" />
            <div class="item_content">
              <p>检验设备</p>
              <p class="inner">
                整合和运用多种技术平台及检测方法，帮助医生精确诊断。
              </p>
            </div>
          </a>
        </el-col>
        <el-col :span="7" class="item">
          <a href="javascript:volid(0)">
            <img src="../../../static/image/kexue.png" alt="" />
            <div class="item_content">
              <p>科学检验</p>
              <p class="inner">为各级医疗机构提供医学检验及诊断服务与支持。</p>
            </div>
          </a>
        </el-col>
      </el-row>
    </div>
    <div class="trademark clearfix">
      <div
        class="trademark_content"
        v-for="(item, key) in trademarkArr"
        :key="key"
      >
        <div class="trademark_item">
          <div class="imgBox">
            <img :src="item.src" alt="" />
          </div>
          <div class="bottom">
            <p>{{ item.title }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  data() {
    return {
      showbtn: false,
      showCode: false, //医晟宝小程序码
      isImage0: true, //图片路径的 控制0
      isImage: true, //图片路径的 控制
      isImage2: true, //图片路径的 控制2
      isImage3: true, //图片路径的 控制3
      isImage4: true, //图片路径的 控制4
      isImage5: true, //图片路径的 控制5
      isImage6: true, //图片路径的 控制6
      isImage7: true, //图片路径的 控制7
      isImage8: true, //图片路径的 控制7
      show: false,
      trademarkArr: [
        { src: '../../../static/image/hzimg/jssrm.png', title: '江苏省人民医院' },
        { src: '../../../static/image/yxb.png', title: '苏州大学医学部' },
        { src: '../../../static/image/hzimg/glyy.png', title: '鼓楼医院' },
        { src: '../../../static/image/zgpa.png', title: '中国平安' },
        { src: '../../../static/image/yfyy.png', title: '逸夫医院' },
        { src: '../../../static/image/ygbx.png', title: '阳光保险集团' },
        {
          src: '../../../static/image/hzimg/dbzq.png',
          title: '中国人民解放军东部战区总医院',
        },
        { src: '../../../static/image/tpybx.png', title: '太平洋保险' },
        { src: '../../../static/image/zgrs.png', title: '中国人寿' },
        { src: '../../../static/image/hzimg/hnsf.png', title: '湖南师范大学医学院' },
        { src: '../../../static/image/hzimg/nfy.png', title: '南京医科大学第四附属医院' },
        { src: '../../../static/image/jsjk.png', title: '江苏省疾控' },
      ],
      newsList: [],
    }
  },
  mounted() {
    this.getNews()
  },
  methods: {
    showButton() {
      this.showbtn = true
    },
    toggle() {
      this.show = !this.show
    },
    onmouseenter0() {
      
      this.isImage0 = false
    },
    onmouseleave0() {
     
      this.isImage0 = true
    },
    onmouseenter() {
      
      this.isImage = false
    },
    onmouseleave() {
      
      this.isImage = true
    },
    onmouseenter2() {
      
      this.isImage2 = false
    },
    onmouseleave2() {
     
      this.isImage2 = true
    },
    onmouseenter3() {
    
      this.isImage3 = false
    },
    onmouseleave3() {
     
      this.isImage3 = true
    },
    onmouseenter4() {
     
      this.isImage4 = false
    },
    onmouseleave4() {
    
      this.isImage4 = true
    },
    onmouseenter5() {
    
      this.isImage5 = false
    },
    onmouseleave5() {
     
      this.isImage5 = true
    },
    onmouseenter6() {
     
      this.isImage6 = false
    },
    onmouseleave6() {
     
      this.isImage6 = true
    },
    onmouseenter7() {
    
      this.isImage7 = false
    },
    onmouseleave7() {
     
      this.isImage7 = true
    },
    onmouseenter8() {
      
      this.isImage8 = false
    },
    onmouseleave8() {
      
      this.isImage8 = true
    },
    // 获取行业新闻
    getNews() {
      const vm = this
      let params = {
        pagination: true,
        typevalue: '1',
        pageNo: 1,
        pageSize: 10,
      }
      vm.axios.get('/news/queryNewsList', { params: params }).then((res) => {
        // console.log(res.data, '/news/queryNewsList')
        vm.newsList = []
        res.data.newsList.list.forEach((val) => {
          val.publishtime = val.publishtime
            ? moment(val.publishtime).utc(0).format('YYYY-MM-DD')
            : ''
          vm.newsList.push(val)
        })
        vm.totalCount = res.data.newsList.count[0].count
      })
    },
    toMoreNews() {
      const vm = this
      this.$router.push({ path: '/news', query: { activeName: 0 } })
    },
    linkTo(index) {
      // let url = ''
      if (index == 0) {
        this.$router.push({ path: '/coronavirus' })
      } else if (index == 1) {
        window.open(
          'http://cloudhisfront.hwason.cn/#/login?redirect=%2Fpharmacy'
        )
      } else if (index == 2) {
        window.open('http://wehealth.hwason.cn/')
      } else if (index == 3) {
        window.open('http://es.hwason.cn')
      } else if (index == 4) {
        window.open('http://222.190.241.194:8005/')
        this.showbtn = false
      } else if (index == 5) {
        window.open('http://58.240.113.114:8005/')
        this.showbtn = false
      } else if (index == 6) {
        window.open('http://122.96.140.90:8081/')
        this.showbtn = false
        //  this.$confirm('系统维护中，如有疑问请联系运维人员。', '提示', {
        //   confirmButtonText: '确定',
        //   showCancelButton: false,
        //   showClose:false,
        //   type: 'warning'
        // });
    
      } else if (index == 7) {
        //  this.$confirm('系统维护中，如有疑问请联系运维人员。', '提示', {
        //   confirmButtonText: '确定',
        //   showCancelButton: false,
        //   showClose:false,
        //   type: 'warning'
        // });
        window.open('http://221.226.78.18:8081/')
        this.showbtn = false
      } else if (index == 8) {
        window.open('http://218.77.52.192:8081/')
        this.showbtn = false
      } else if (index == 9) {
        window.open('http://116.128.245.22:8081/')
        this.showbtn = false
      } else if (index == 10) {
        window.open('http://1.192.212.236:8088/')
        this.showbtn = false
      } else if (index == 11) {
        window.open('http://218.29.80.210:8088/')
        this.showbtn = false
      } else if (index == 12) {
        window.open('https://whale.hwason.cn/#/login')
        this.showbtn = false
      } else if (index == 13) {
        window.open('https://admin.hwason.cn/frontadmin/login')
        this.showbtn = false
      } else if (index == 14) {
        window.open('https://cloud.hwason.cn/soyoung/index.html')
        this.showbtn = false
      } else if (index == 15) {
        this.showCode = true
        this.showbtn = false
      }

      // window.location.href = url
    },
  },
}
</script>

<style lang="scss" scoped>
/deep/.homeSend .el-dialog__body {
  text-align: center;
}
/deep/.el-dialog__wrapper {
  position: fixed;
  top: 20%;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  margin: 0;
  /deep/.el-dialog__body {
    /deep/.showUrl:hover {
      color: #0068b7;
    }
  }
  /deep/.el-dialog {
    position: relative;
    margin: 0 auto 50px;
    border-radius: 2px;
    -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 26%;
    min-height: 320px;
    /deep/.el-dialog__header {
      width: 350px;
      margin: auto;
      text-align: left;
      .el-dialog__title {
        color: #0068b7;
        font-size: 20px;
        font-weight: 700;
      }
    }
  }
}

/deep/.el-dialog__header {
  text-align: left;
  cursor: pointer;
}
.index {
  width: 100%;
  .news {
    margin: 0 8%;
    height: 60px;
    line-height: 60px;
    border-bottom: 1px solid #999999;
    position: relative;
    .carousel {
      position: absolute;
      left: 48px;
      top: 0;
      width: 88%;
      font-size: 15px;
    }
    img {
      vertical-align: middle;
    }
    .first {
      color: #999999;
      padding: 0px 30px 0 20px;
    }
    .more {
      float: right;
      color: #0068b7;
      cursor: pointer;
    }
  }
  .enterBox .imgBox img {
    width: 160px;
    height: 160px;
    border-radius: 50%;
  }
  .imgBox {
    text-align: center;
    margin: 0 auto;
    margin-bottom: 12px;
  }

  .showFeatures {
    padding: 90px 8% 70px;
    width: 100%;
    box-sizing: border-box;
    .new-item {
      margin: 0 auto 45px;
      .imgBox {
        margin-bottom: 0px;
        img {
          width: 200px;
          height: 200px;
        }
      }
    }
    /deep/ .el-carousel__container {
      height: 320px;
    }

    a {
      &:hover .imgBox img {
        border-radius: 50%;
        box-shadow: 0px 0px 25px 0px rgba(0, 0, 0, 0.35);
      }
      &:hover p {
        color: #0068b7;
      }
    }
    p {
      text-align: center;
      &:last-child {
        color: #000;
      }
    }
    .title {
      font-size: 22px;
      height: 60px;
      line-height: 60px;
    }
    .tip {
      font-size: 14px;
    }
    .new-item .title {
      font-size: 24px;
    }
  }

  .introduce {
    padding: 0 8%;
    padding-top: 45px;
    // height: 830px;
    background-color: #d8e8f0;
    .description {
      .top {
        text-align: center;
        font-size: 18px;
        color: #0068b7;
        margin-bottom: 35px;
      }
    }
  }

  .show {
    width: 100%;
    margin: 90px 0;
    .item {
      float: left;
      width: 33.3%;
      box-sizing: border-box;
      position: relative;
      &:hover .item_content {
        height: 176px;
      }
      img {
        width: 100%;
      }
      .item_content {
        position: absolute;
        width: 100%;
        bottom: 4px;
        height: 65px;
        padding-top: 11px;
        background-color: rgba(40, 123, 187, 0.8);
        text-align: center;
        transition: all 1s;
        overflow: hidden;

        p {
          height: 60px;
          line-height: 60px;
          color: #fff;
          font-size: 26px;
        }
        .inner {
          font-size: 18px;
          height: 50px;
          line-height: 50px;
        }
      }
    }
  }

  .trademark {
    padding: 0 7% 0 8%;
    margin-bottom: 62px;
    display: flex;
    flex-wrap: wrap;
    .trademark_content {
      float: left;
      width: 16.6%;
      height: 16.6%;
      margin-bottom: 28px;
      .trademark_item {
        width: 90%;
        background-color: #c1daea;
        text-align: center;
        .imgBox {
          width: 100%;
          height: 160px;
          position: relative;
          padding-bottom: 0;
          img {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }
        .bottom {
          width: 100%;
          height: 40px;
          line-height: 40px;
          background-color: #60a1d0;
          color: white;
        }
      }
    }
  }
}
.BVI {
  margin-top: 20px;
  a {
    color: #b1b3b3;
    &:hover {
      color: #0068b7;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/website/index.vue